import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import List from '@/assets/common/List/List.vue'
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';


type Committee = {
    id: string;
    name: string;
    repId: null;
    isHidden: boolean;
    isDeletable: boolean;
    committeeWorkers:Producers[];
}

type CommitteesGet = {
    committees: Committee[];
}

type Producers = {
    pdId: string;
    pdName: string;
    dateOfBirth: string;
}

type ProducersGet = {
    producers: Producers[];
}


@Component({
    components: {
        List
    }
})
export default class Committees extends Vue {
    private list: any | null = null
    private title = '部会'
    private baseUrl = '/committees';
    private producersUrl = '/producers'
    private clientBaseUrl = '/master/committees'
    private committees: Committee[] = []
    private producersList : Producers[] = []
    private withHidden = false
    private isLoading = false
    private headerTitle!: string
    private selectedCommittee!: Committee
    private committeeId = ""
    private committeeName = ""
    private isHidden = false
    private isDeletable = true
    private selectedProducers = [] as string[]
    selectedProducersList : Producers[] = []
    private averageAge: number | null = null
    private existingSelectedProducers : Producers[] = []
    private selectedRepId = null
    private existingSelectedRepId = null

    @Prop()
    private id!: string

    private created() {
        this.getCommittees(false)
        if(this.id){
        this.setCommittees(this.id,false)
        }
    }

    private getCommittees(withHidden: boolean) {
        this.list = null;
        this.isLoading = true;
    
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=${withHidden}`)
            .then(res => {
                this.committees = (toCamel(res) as CommitteesGet).committees as Committee[];
            })
            .catch(error => {
                console.error('Failed to fetch committees:', error);
            })
            .finally(() => {
                this.list = List;
                this.isLoading = false;
            });
    }

    private getProducers() {
        this.$apiClient
            .doRequest('get', `${this.producersUrl}`)
            .then(res => {
                this.producersList = (toCamel(res) as ProducersGet).producers as Producers[];
            })
            .catch(error => {
                console.error('Failed to fetch producers:', error);
            });
    }

    private createCommittees(flag:boolean) {
        this.$router.push(`${this.clientBaseUrl}/`, () => {return})
        if(store.getters.isInputChanged==false){
            this.headerTitle = "新規部会"
            this.committeeId = "create"
            this.committeeName = ""
            this.selectedRepId = null
            this.selectedProducers = []
            this.existingSelectedRepId = null
            this.existingSelectedProducers = []
            this.selectedProducersList= []
            this.isHidden = false
        }
        if(flag){
            this.openSideBar();
        }
        this.getProducers()
    }

    private toggleHiddenItems(value: boolean) {
        this.withHidden = value;
        this.getCommittees(this.withHidden)
    }

    private setCommittees(committeeId: string, flag:boolean) {
        this.headerTitle = "部会情報"
        this.getProducers()
        this.$router.push(`${this.clientBaseUrl}/${committeeId}`, () => {return})
        if(store.getters.isInputChanged==false){
        this.$apiClient.doRequest("get", `${this.baseUrl}/${committeeId}`).then((res) => {
            const item = this.selectedCommittee = toCamel(res) as Committee
            this.committeeId = item.id
            this.committeeName = item.name
            this.selectedRepId = item.repId
            this.existingSelectedRepId = item.repId
            this.isHidden = item.isHidden
            this.selectedProducersList = item.committeeWorkers
            
            this.selectedProducersList.forEach(selected => {
                const match = this.producersList.find(p => p.pdId === selected.pdId);
                if (match) {
                  selected.pdName = match.pdName;
                }
              });
              this.selectedProducersList.sort((a, b) => {
                const nameA = a.pdName?.toLowerCase() || '';
                const nameB = b.pdName?.toLowerCase() || '';
                return nameA.localeCompare(nameB);
                });
            this.selectedProducers = item.committeeWorkers.map(worker => worker.pdId)
            this.existingSelectedProducers =item.committeeWorkers as Producers[]
            this.isDeletable = item.isDeletable
        })
        if(flag){
            this.openSideBar();
        }
      }
    }

    private switchDisplay() {
        if (!window.confirm(`${this.selectedCommittee.name}を${ this.isHidden ? '表示状態に戻します' : '非表示にします' }。よろしいですか？`)){
            return
        }
        this.isLoading = true
        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.committeeId}/display`).then(() => {
            this.isHidden = !this.isHidden;
            this.$router.push(`${this.clientBaseUrl}/${this.committeeId}`, () => {return});
            this.getCommittees(this.withHidden)
            this.$toasted.success(this.isHidden ? '非表示に変更しました。' : '表示に変更しました。' )
        })
        .catch(() => {
            this.$toasted.error('変更に失敗しました。')
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    private cancelEdit() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        if(this.committeeId !== 'create') {
            this.setCommittees(this.committeeId,false)
        } else {
            this.createCommittees(false)
        }
    }

    private submit() {
        const errmsg: string[] = []
        // 名前の入力
        if(!this.committeeName.trim()) {
            errmsg.push("部会名を入力してください")
        }
        // 名前の長さ
        if(this.committeeName.length > 100) {
            errmsg.push(`部会名は100文字以内で入力してください（現在は${this.committeeName.length}文字）`)
        }
        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        this.isLoading = true
        const params = {
            name: this.committeeName.trim(),
            repId: this.selectedRepId,
            addedProducers: this.selectedProducers.filter(
                id => !this.existingSelectedProducers.some(p => p.pdId === id)
              ),
            deletedProducers: this.existingSelectedProducers
                .filter(producer => !this.selectedProducers.includes(producer.pdId))
                .map(producer => producer.pdId)
        }

        if (this.committeeId === "create") {
            this.$apiClient.doRequest("post", `${this.baseUrl}`, params).then((res) => {
                this.$router.push(`${this.clientBaseUrl}/${res.id}`, () => {return})
                this.getCommittees(this.withHidden)
                this.$toasted.success('保存しました。')
                this.$store.dispatch('doUpdateIsInputChanged', false);
                this.setCommittees(res.id, false)
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        } else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                this.isLoading = false
                return false;
            }
            this.$apiClient.doRequest("put", `${this.baseUrl}/${this.committeeId}`, params).then(() => {
                this.getCommittees(this.withHidden)
                this.$toasted.success('変更を保存しました。')
                this.$store.dispatch('doUpdateIsInputChanged', false);
                this.setCommittees(this.committeeId, false)
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }
    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    deleteCommittee() {
        const confirm = window.confirm('削除しますか？')

        this.isLoading = true
        if(confirm) {
            this.$apiClient.doRequest('delete', `${this.baseUrl}/${this.id}`)
                .then(() => {
                    this.$toasted.success('削除しました。')
                    this.$router.push(`${this.clientBaseUrl}`).then(() => { return })
                    this.getCommittees(this.withHidden)
                    this.createCommittees(false);
                })
                .catch(() => {
                    this.$toasted.error('削除に失敗しました。')
                })
        } else {
            this.$toasted.success('削除がキャンセルされました。')
            this.isLoading = false
        }

    }

    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if(document.body.classList.contains('sideopen')){
            document.body.classList.remove('sideopen')
        }else{
            document.body.classList.add('sideopen')
        }
    }



    selectCheckBox(){
        this.selectedProducersList = this.producersList.filter(producer =>
            this.selectedProducers.includes(producer.pdId)
        );
        this.inputChanged();
    }

    @Watch('selectedProducers')
    onSelectedItemsChanged() {
        const repIdExists = this.selectedProducersList.some(
            producer => producer.pdId === this.selectedRepId
        );
        if (!repIdExists) {
            this.selectedRepId = null;
        }
        const ages = this.producersList
            .filter(producer => this.selectedProducers.includes(producer.pdId))
            .map(producer => this.calculateAge(producer.dateOfBirth))
            .filter(Boolean) as number[]
        this.averageAge = ages.length ? Math.round((ages.reduce((sum, age) => sum + age, 0) / ages.length) * 10) / 10 : null;
    }

    private calculateAge(dobString: string): number | null {
        if (!dobString) return null;
        const dob = new Date(dobString)
        if (isNaN(dob.getTime())) return null
        const today = new Date()
        let age = today.getFullYear() - dob.getFullYear()
        if (today.getMonth() < dob.getMonth() || (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())) {
            age--
        }
        return age
    }

}

